















































import { VModel, Prop, Component, Emit } from "vue-property-decorator";
import { ChannelsApi } from "@/includes/Api/Channels.api";
import { UserInfo } from "@/includes/types/UserInfo";
import { errorNotification, successNotification } from "@/includes/services/NotificationService";
import Vue from "vue";
import moment from 'moment'
import UserMainInfo from "piramis-base-components/src/components/UserMainInfo.vue";
import EmptyData from 'piramis-base-components/src/components/EmptyData/EmptyData.vue'

@Component({
  components: {
    UserMainInfo,
    EmptyData
  },
  data() {
    return {
      moment
    }
  }
})
export default class FaceControlModal extends Vue {
  @VModel() isModal!: boolean
  @Prop() count!: number
  @Emit() onDelete() {}

  intruders: Array<UserInfo> = []
  page: number = 1

  PAGE_SIZE = 10

  created() {
    this.load(this.PAGE_SIZE, 0)
  }

  onPageChange(page, limit) {
    this.load(limit, (page - 1) * limit)
  }

  load(limit: number, offset: number) {
    ChannelsApi.getIntruders("tg", {
      board_key: this.$store.state.boardsState.activeBoard?.board,
      channel_id: this.$store.state.channelsState.activeChannel?.id,
      limit: limit,
      offset: offset
    }).then(response => this.intruders = response.users)
      .catch(cause => {
        this.count = 0
        this.intruders = []

        errorNotification(cause)
      });
  }

  confirm() {
    this.$confirm({
      title: this.$t('channel_face_control_delete_members_confirm_message'),
      onOk: this.deleteMembers
    })
  }

  deleteMembers() {
    ChannelsApi.deleteIntruders("tg", {
      board_key: this.$store.state.boardsState.activeBoard?.board,
      channel_id: this.$store.state.channelsState.activeChannel?.id
    }).then(() => {
      this.onDelete()

      this.isModal = false
    }).catch(cause => errorNotification(cause));
  }
}
